export const checkoutErrorMessage = {
  // required messages
  firstNameRequired: "First Name is required.",
  lastNameRequired: "Last Name is required.",
  phoneNumberRequired: "Phone number is required",
  emailRequired: "Email is required.",
  addressRequired: "Address is required.",
  countryRequired: "Country is required.",
  stateRequired: "State is required.",
  cityRequired: "City is required.",
  zipCodeRequired: "Zip Code is required",

  // validation messages
  firstNameValidate: "First Name must contain only alphabetic characters",
  lastNameValidate: "Last Name must contain only alphabetic characters",
  emailValidate: "Enter a valid email address.",
  phoneNumberInvalid: "Enter a valid phone number.",
};

export const contactUsErrorMessage = {
  fullNameValidate: "Full Name must contain only alphabetic characters",
  emailValidate: "Enter a valid email address.",
  phoneNumberInvalid: "Enter a valid phone number.",

  fullNameRequired: "Full Name is required.",
  messageRequired: "Message is required.",
  emailRequired: "Email is required.",
  phoneNumberRequired: "Phone number is required",
};
